import {HttpClient} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {LocaleService} from './services/locale/locale.service';


@NgModule()
export class AppModule {
  constructor(private localeService: LocaleService) {
    this.localeService.defineUsedLocales();
  }
}

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
